module.exports = __webpack_public_path__ + "static/media/Elements_ComputerIcon.a6691d01.svg";